import moment from "moment";
import "moment-timezone";

// TODO: replace this with https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#locale_options
//service is a UTC timestamp, display is a PST 'yyyy/MM/DD'
export function serviceToDisplay(
  date: Date,
  dateFormat = "yyyy/MM/DD"
): string {
  return moment(date).tz("America/Los_Angeles").format(dateFormat);
}

export function serviceToDisplayUTC(
  date: Date,
  dateFormat = "yyyy/MM/DD"
): string {
  return moment(date).utc().format(dateFormat);
}

export function convertDateStringToUTCDate(dateString: string): Date {
  return moment.utc(dateString).toDate();
}

export function getRelativeDate(
  date: Date,
  amount: number,
  unit: "second" | "minute" | "hour" | "day" | "week" | "month" | "year"
): Date {
  return moment(date).add(amount, unit).toDate();
}

export function getCurrentEpochMilliseconds(): number {
  return Date.now();
}

export function getResetEpochMilliseconds(): number {
  // The date is 12/31/2037. JS months are zero indexed.
  return Date.UTC(2037, 11, 31);
}

export function getPstOffset(date: Date): number {
  return moment.utc(date).tz("America/Los_Angeles").utcOffset();
}

export function serviceEpochMillisToString(millis: number | undefined): string {
  return millis ? serviceToDisplay(new Date(millis)) : "";
}

export function isWithin24Hours(
  date: Date,
  currentTime: Date = new Date()
): boolean {
  const twentyFourHoursInMilliseconds = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
  const timeDifference = Math.abs(date.getTime() - currentTime.getTime());

  return timeDifference <= twentyFourHoursInMilliseconds;
}

export const DATE_FORMAT_LENGTH = 10;

export type AnnounceDateClassification =
  | "past"
  | "current"
  | "future"
  | "missing";

export function classifyAnnounceDate(
  announceDate: Date | null | undefined,
  now?: Date
): AnnounceDateClassification {
  if (announceDate == null) {
    return "missing";
  }

  const announceMoment = moment(announceDate);
  if (!announceMoment.isValid()) {
    return "missing";
  }

  const tz = "America/Los_Angeles";
  const announceDay = announceMoment.tz(tz).format("YYYY-MM-DD");
  const todayDay = moment(now ?? new Date())
    .tz(tz)
    .format("YYYY-MM-DD");

  if (announceDay < todayDay) return "past";
  if (announceDay === todayDay) return "current";
  return "future";
}
